document.addEventListener("DOMContentLoaded", () => {
    const regulation = document.querySelector("#register-regulation_accept");
    const register_policy_input = document.querySelector("#register-privacy_policy");
    if(regulation && register_policy_input){
        regulation.addEventListener("change", ()=> {
            if(regulation.checked && register_policy_input.checked){
                document.querySelector(".login__main .btn_register").disabled = false;
            }else {
                document.querySelector(".login__main .btn_register").disabled = true;
            }
        })
        register_policy_input.addEventListener("change", ()=> {
            if(register_policy_input.checked && regulation.checked){
                document.querySelector(".login__main .btn_register").disabled = false;
            }else {
                document.querySelector(".login__main .btn_register").disabled = true;
            }
        })
    }
    const contact_input = document.querySelector("#contact-accept-input");
    if(contact_input){
        contact_input.addEventListener("change", () => {
            if(contact_input.checked){
                document.querySelector(".contact-form__button-wrapper .custom-contact-btn").disabled = false;
            }else {
                document.querySelector(".contact-form__button-wrapper .custom-contact-btn").disabled = true;
            }
        })
    }
    const cart_drawer_terms_input = document.querySelector("#regulation_accept");
    const cart_drawer_policy_input = document.querySelector("#privacy_policy");
    if(cart_drawer_policy_input && cart_drawer_terms_input){
        cart_drawer_terms_input.addEventListener("change", () => {
            if(cart_drawer_terms_input.checked && cart_drawer_policy_input.checked){
                document.querySelector(".quick-cart__wrapper .quick-cart__submit").disabled = false;
            }else {
                document.querySelector(".quick-cart__wrapper .quick-cart__submit").disabled = true;
            }
        });
        cart_drawer_policy_input.addEventListener("change", () => {
            if(cart_drawer_terms_input.checked && cart_drawer_policy_input.checked){
                document.querySelector(".quick-cart__wrapper .quick-cart__submit").disabled = false;
            }else {
                document.querySelector(".quick-cart__wrapper .quick-cart__submit").disabled = true;
            }
        })
    }
    var popup_interval;
    
    popup_interval = setInterval(function popup_find(){
        if(document.querySelector(".qsk-popup__box-form .qsk-popup__field-action")) {
            clearInterval(popup_interval);//btn_disable
            document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
            document.querySelector(".qsk-popup__box-form .qsk-popup__form").style.marginBottom = "0px";
            document.querySelector(".qsk-popup__body .qsk-popup__body-box .qsk-popup__box-content").style.marginTop = "40px";
            var embedHTML = 
            `<div class="popup_confirm_accept">
                <input type="checkbox" name="privacy_policy"
                    aria-required="true" id="popup_privacy_policy"
                >
                <label for="popup_privacy_policy">Potwierdzam, że zapoznałem się z <a href="https://starhouselove.com/policies/privacy-policy">polityką prywatności</a> sklepu 
                    internetowego.
                </label>
            </div>
            <div class="popup_confirm_accept">
                <input type="checkbox" name="accept_personal"
                    aria-required="true" id="popup_accept_personal"
                >
                <label for="popup_accept_personal">
                    <div class="personal_description">
                        Zgadzam się na przetwarzanie moich danych osobowych (adres email) 
                        przez Sprzedawcę (SHG Sp. z o.o., ul. T. Kościuszki 130C/31, 50-439 
                        Wrocław) w celu marketingowym. Wyrażenie zgody jest dobrowolne. Mam 
                        prawo cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z 
                        prawem przetwarzania, którego dokonano na podstawie zgody przed jej 
                        cofnięciem. Mam prawo dostępu do treści swoich danych i ich sprostowania, 
                        usunięcia, ograniczenia przetwarzania, oraz prawo do przenoszenia danych 
                        na zasadach zawartych w <a href="https://starhouselove.com/policies/privacy-policy">polityką prywatności</a> sklepu internetowego. Dane osobowe w sklepie 
                        internetowym przetwarzane są zgodnie z <a href="https://starhouselove.com/policies/privacy-policy">polityką prywatności</a>. Zachęcamy do zapoznania się z 
                        polityką przed wyrażeniem zgody.
                    </div>
                    <input type="checkbox" id="popup-accept-view-more">
                    <label for="popup-accept-view-more">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.3348 14L9.69727 8.36246L11.3077 6.75208L18.5555 14L11.3077 21.2479L9.69727 19.6375L15.3348 14Z" fill="#272850"></path>
                        </svg>
                    </label>
                </label>
                
            </div>
            `;
            var create_ele = document.createElement('div');
            create_ele.className = "custom_popup_fields";
            create_ele.innerHTML = embedHTML;
            document.querySelector(".qsk-popup__box-form .qsk-popup__form").appendChild(create_ele);
        }
        const popup_privacy_policy = document.querySelector("#popup_privacy_policy");
        const popup_accept_personal = document.querySelector("#popup_accept_personal");
        if(popup_privacy_policy && popup_accept_personal){
            popup_privacy_policy.addEventListener("change", () => {
                console.log("privacy_policy");
                if(popup_privacy_policy.checked && popup_accept_personal.checked){
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = false;
                }else {
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
                }
            });
            popup_accept_personal.addEventListener("change", () => {
                console.log("popup_accept_personal");
                if(popup_privacy_policy.checked && popup_accept_personal.checked){
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = false;
                }else {
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
                }
            })
        }
    }, 1000);
    
  })